<template>
    <div>
		<action-sidebar
			title=""
			:value="true"
			:width="480"
			@close-modal="closeModal"
		>
			<div class="wrapper">
				<h2 class="modal-title"
					:style="`color:${$appColors.primary}`"
				>Tipo de Herramienta</h2>
				<template-tools :templates="templates"></template-tools>
				<div class="modal-btn-container">
					<app-button
						class="close-btn"
						:style="`background-color:${$appColors.error}`"
						text="Cerrar"
						@click="closeModal"
					/>
				</div>
			</div>
		</action-sidebar>
    </div>
</template>
<script>
import actionSidebar from '@/components/shared/action-sidebar';
import appButton from '@/components/shared/app-button';
import templateTools from '@/components/configuration/tools/template-tools';
import { mapState } from 'vuex';

function created() {
	this.$store.dispatch('tool/loadToolType');
}

function closeModal() {
	this.goTo('new-tool');
}

function data() {
	return {
		dataTemplates: [
			{
				title: 'Clima Laboral',
				code: 'CL',
				id: 1,
				aspects: [
					{
						title: 'Criterios',
						content: 'El contenido de criterios',
						imgs: [],
					},
					{
						title: 'Factores',
						content: 'El contenido de Factores',
						imgs: [],
					},
					{
						title: 'Preguntas',
						content: 'El contenido de preguntas',
						imgs: [],
					},
				],
			},
			{
				title: 'Diagnóstico Organizacional',
				code: 'DO',
				id: 2,
				aspects: [
					{
						title: 'Criterios',
						content: 'El contenido de criterios',
						imgs: [],
					},
					{
						title: 'Factores',
						content: 'El contenido de Factores',
						imgs: [],
					},
					{
						title: 'Preguntas',
						content: 'El contenido de preguntas',
						imgs: [],
					},
				],
			},
		],
	};
}

export default {
	name: 'tool-type-modal',
	components: {
		actionSidebar,
		appButton,
		templateTools,
	},
	computed: {
		...mapState('tool', {
			templates: state => state.templates,
		}),
	},
	created,
	data,
	methods: {
		closeModal,
	},
};
</script>
<style lang="scss" scoped>
.wrapper {
	background-color: color(gray-light);
	height: inherit;

	.modal-title {
		border-bottom: 1px solid color(gray-slider);
		font-family: font(bold);
		font-size: size(xlarge);
		margin: 0px 20px 20px;
		padding-bottom: 12px;
		padding-top: 30px;
	}
	.modal-btn-container {
		background-color: white;
		bottom: 0;
		display: flex;
		justify-content: center;
		padding: 20px;
		position: fixed;
		width: 100%;
		
		.close-btn {
			border-radius: 5px;
			color: white;
			padding: 5px 30px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/configuration/tool-type-modal.vue